import { BufferUsage } from "../../RenderEngine/RenderEnum/BufferTargetType";
import { DrawType } from "../../RenderEngine/RenderEnum/DrawType";
import { IndexFormat } from "../../RenderEngine/RenderEnum/IndexFormat";
import { MeshTopology } from "../../RenderEngine/RenderEnum/RenderPologyMode";
import { LayaGL } from "../../layagl/LayaGL";
import { SpineShaderInit } from "../material/SpineShaderInit";
export class SpineMeshBase {
    get material() {
        return this._material;
    }
    set material(value) {
        this._material = value;
        this.element.materialShaderData = this._material._shaderValues;
        this.element.subShader = this._material._shader.getSubShaderAt(0);
    }
    constructor(material) {
        this.verticesLength = 0;
        this.indicesLength = 0;
        this.vertexBufferLength = 0;
        this.indexBufferLength = 0;
        this.init();
        this.material = material;
    }
    init() {
        let geo = LayaGL.renderDeviceFactory.createRenderGeometryElement(MeshTopology.Triangles, DrawType.DrawElement);
        let mesh = LayaGL.renderDeviceFactory.createBufferState();
        geo.bufferState = mesh;
        let vb = LayaGL.renderDeviceFactory.createVertexBuffer(BufferUsage.Dynamic);
        let ib = LayaGL.renderDeviceFactory.createIndexBuffer(BufferUsage.Dynamic);
        vb.vertexDeclaration = this.vertexDeclarition;
        mesh.applyState([vb], ib);
        geo.indexFormat = IndexFormat.UInt16;
        this.geo = geo;
        this.vb = vb;
        this.ib = ib;
        this.element = LayaGL.render2DRenderPassFactory.createRenderElement2D();
        this.element.nodeCommonMap = ["BaseRender2D", "spine2D"];
        this.element.canotPool = true;
        this.element.geometry = geo;
        this.element.renderStateIsBySprite = false;
    }
    get vertexDeclarition() {
        return SpineShaderInit.SpineNormalVertexDeclaration;
    }
    draw() {
        let vb = this.vb;
        let ib = this.ib;
        let vblen = this.verticesLength * 4;
        let iblen = this.indicesLength * 2;
        if (vblen > this.vertexBufferLength) {
            vb.setDataLength(vblen);
            this.vertexBufferLength = vblen;
        }
        if (iblen > this.indexBufferLength) {
            ib._setIndexDataLength(iblen);
            this.indexBufferLength = iblen;
        }
        vb.setData(this.vertexArray.buffer, 0, this.vertexArray.byteOffset, vblen);
        ib._setIndexData(new Uint16Array(this.indexArray.buffer, this.indexArray.byteOffset, iblen / 2), 0);
        this.geo.clearRenderParams();
        this.geo.setDrawElemenParams(iblen / 2, 0);
        this.element.geometry = this.geo;
    }
    drawByData(vertices, vblength, indices, iblength) {
        this.vertexArray = vertices;
        this.indexArray = indices;
        this.verticesLength = vblength;
        this.indicesLength = iblength;
        this.draw();
    }
    clear() {
        this.verticesLength = 0;
        this.indicesLength = 0;
    }
    destroy() {
        this.clear();
        this.vb.destroy();
        this.ib.destroy();
        this.geo.destroy();
        this.element.destroy();
    }
    _cloneTo(target) {
        target.verticesLength = this.verticesLength;
        target.indicesLength = this.indicesLength;
        target.vertexArray = new Float32Array(this.vertexArray);
        target.indexArray = new Uint16Array(this.indexArray);
    }
}
SpineMeshBase.maxVertex = 10922;
